import { DocumentType } from '@bulthaup/api/db';
import { Button, Card, Group, Stack, Text, Title } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';

import { trpc } from '../../../../../services/trpc';
import { getUTDocumentUrl } from '../../../../../services/upload';
import { ConstructionSiteReportSection } from './-construction-site-report-section';
import { ServiceOrderRequestSection } from './-service-order-request-section';

export const Route = createFileRoute('/app/projets/$slug/poseur/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { data: project } = trpc.projects.get.useQuery({ slug: params.slug });

  if (!project) {
    return null;
  }

  const technicalPlanDocument = project.documents.find(
    document => document.type === DocumentType.TECHNICAL_PLAN,
  );

  return (
    <Stack>
      <Title order={3}>Plan technique</Title>
      <Card>
        {technicalPlanDocument ? (
          <Group>
            <Text c="dimmed" size="sm">
              {technicalPlanDocument.fileName}
            </Text>
            <Button
              leftSection={<IconEye size={16} />}
              variant="outline"
              onClick={() => {
                window.open(
                  getUTDocumentUrl(technicalPlanDocument.utFileKey),
                  '_blank',
                );
              }}
            >
              Voir le plan technique
            </Button>
          </Group>
        ) : (
          <Text c="dimmed" size="sm">
            Aucun plan technique disponible
          </Text>
        )}
      </Card>
      <Title order={3}>PV de chantier</Title>
      <Card>
        <ConstructionSiteReportSection project={project} />
      </Card>
      <Title order={3}>Fiche d'intervention</Title>
      <Card>
        <ServiceOrderRequestSection project={project} />
      </Card>
    </Stack>
  );
}
